import { z } from 'zod';

export const OngoingAccessModeSchema = z.enum(['standard', 'gift', 'pair']);
export const OngoingAccessActionTypeSchema = z.enum([
  'create_invite_link',
  'revoke_invite_link',
  'deliver_package',
]);
export const OngoingAccessErrorCodeSchema = z.enum([
  'invalid_reference',
  'identity_mismatch',
  'quota_exhausted',
  'capability_disabled',
  'outcome_unknown',
  'external_failure',
]);

/**
 * Reference-only contract for the later access-bot runtime. Bearer URLs,
 * contacts, raw evidence, tokens and encryption material are intentionally
 * impossible to represent here.
 */
export const OngoingAccessActionJobSchema = z
  .object({
    actionId: z.string().uuid(),
    actionType: OngoingAccessActionTypeSchema,
    purchaseId: z.string().uuid().optional(),
    seatId: z.string().uuid().optional(),
    destinationId: z.string().uuid().optional(),
    invitationLinkId: z.string().uuid().optional(),
    telegramUserId: z
      .string()
      .regex(/^[1-9]\d{0,19}$/)
      .optional(),
    attempt: z.number().int().positive(),
  })
  .strict();

export const OngoingAccessActionResultSchema = z
  .object({
    actionId: z.string().uuid(),
    outcome: z.enum(['succeeded', 'failed', 'outcome_unknown']),
    errorCode: OngoingAccessErrorCodeSchema.optional(),
  })
  .strict();

export const OngoingAccessMaskedReadSchema = z
  .object({
    purchaseId: z.string().uuid(),
    clubId: z.string().uuid(),
    mode: OngoingAccessModeSchema,
    status: z.string().min(1).max(64),
    contactMask: z.string().max(32).nullable(),
    seatStates: z.array(
      z.object({
        seatId: z.string().uuid(),
        ordinal: z.number().int().positive(),
        telegramUserId: z
          .string()
          .regex(/^[1-9]\d{0,19}$/)
          .nullable(),
        status: z.string().min(1).max(64),
      }),
    ),
    invitationState: z.string().min(1).max(64).nullable(),
  })
  .strict();

export type OngoingAccessActionJob = z.infer<typeof OngoingAccessActionJobSchema>;
export type OngoingAccessActionResult = z.infer<typeof OngoingAccessActionResultSchema>;
export type OngoingAccessMaskedRead = z.infer<typeof OngoingAccessMaskedReadSchema>;
